import createModel from 'utils/model'
import {wWorkAgents, task, usersActions} from 'services/public'

export default createModel({
    namespace: 'publicConfig',

    state: {
        wWorkPluginAgent: {},
    },

    effects: {
        // 企业微信侧边栏
        *wWorkAgents({payload}, {call, put}) {
            const res = yield call(wWorkAgents, payload)
            yield put({
                type: 'setProperty',
                payload: {
                    wWorkPluginAgent: (Array.isArray(res.data) && res.data[0]) || {},
                },
            })
        },
        // 任务
        *task({payload}, {call}) {
            return yield call(task, payload)
        },
        *usersActions({payload}, {call}) {
            try {
                return yield call(usersActions, payload)
            } catch (e) {
                // console.error(e)
            }
        },
    },

    reducers: {},
})
